import type { JSX } from "react";

import { GuideHeaderMotion } from "../../GuideHeaderMotion";
import { GuideHeaderVitals } from "../../GuideHeaderVitals";
import { Reveal } from "../../Reveal";
import type { SectionRenderInput } from "./types";

import { toAsciiUpper } from "@/lib/time";

/** 1. Compact identity header — the posts lead, the type is the frame. */
export function IdentitySection({ page, section }: SectionRenderInput): JSX.Element {
  return (
    <section className="atlas-guide-identity">
      <GuideHeaderMotion />
      <Reveal variant="rise" className="atlas-guide-hero-city">
        <h1 className="atlas-guide-city">{toAsciiUpper(page.name)}</h1>
      </Reveal>
      <Reveal variant="stamp" delay={120} className="atlas-guide-hero-meta">
        <p className="atlas-guide-meta">
          {toAsciiUpper(page.name)}, {page.country.toUpperCase()}
        </p>
      </Reveal>
      {/* The readings are their own item because the identity is a
        two-column row on desktop and this is what takes the right column,
        beside the name. Which readings, and in what order, is the section's own
        setting: an author keeps the cells a city actually has data for. */}
      <Reveal variant="stamp" delay={160} className="atlas-guide-hero-vitals">
        <GuideHeaderVitals live={page.live} timezone={page.timezone} cells={section.cells} />
      </Reveal>
    </section>
  );
}
